<template>
    <div>
         <audio ref="audioPlayer" class="video-js fill-height" style="
    width: 100%;"></audio>    
    </div>
</template>

<script>
import videojs from 'video.js';
import '../../../node_modules/video.js/dist/video-js.css';

export default {
    name: "AudioPlayer",
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        },
    },
    data() {
        return {
            player: null,
            lastPlay: '',
        }
    },
    mounted() {
        this.player = videojs(this.$refs.audioPlayer, this.options, function onPlayerReady() {
            console.log('onAudioPlayerReady', this);
        })
    },
    updated(){
        console.log("Updated")
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    }
}
</script>